var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "badge", class: _vm.enabled ? "badge-on" : "badge-off" },
    [
      _c("span", { staticClass: "badge-dot" }),
      _vm._v(
        "\n  " +
          _vm._s(
            _vm.enabled
              ? _vm.$t("statusLabel.enabled")
              : _vm.$t("statusLabel.disabled")
          ) +
          "\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }